/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

 const current_url = window.location.href;
  ////////////////////////////////////////////////////////
////   for sticky header
if(!current_url.match("pages/brands")) {
  let prevScrollpos = window.pageYOffset;
  let headerDiv = document.querySelector("#shopify-section-header");
  let headerBottom = headerDiv.offsetTop + headerDiv.offsetHeight;
  let cartPopup = document.querySelector(".cart-notification");

  window.onscroll = function() {
    /* when scrolling down */
    if (window.scrollY <= 0 ){
      headerDiv.style.position = "relative";
      cartPopup.classList.add("cart-notification--fixed");
    } else {
      headerDiv.style.position = "sticky";
      cartPopup.classList.remove("cart-notification--fixed");
    } 

    // prevScrollpos = currentScrollPos;
  }
}

 ////////////////////////////////////////////////////////
////   for long description add 'Show more' btn
if (current_url.match("/collections")) {
  const bttn = document.querySelector('[data-control-descr="show_more"]');
  if (bttn !==null) {
    bttn.dataset.state = 0;
    bttn.addEventListener('click', function() {
    const descr = this.previousElementSibling;
          descr.dataset.tmp = descr.textContent;
          descr.textContent = descr.dataset.content;
          descr.dataset.content = descr.dataset.tmp;
          this.innerHTML = this.dataset.state == 1 ? `Show More... &#11167;` : `Show Less... &nbsp; &#11165;`;
          this.dataset.state = 1-this.dataset.state;
    })
    const descr = document.querySelector('[data-control-descr="description"]');
    descr.dataset.content = descr.textContent;
    descr.textContent = descr.textContent.substr(0, 200) + '...';
  }
}

   ////////////////////////////////////////////////////////
  ////   for animate text in search input placeholder
 const texts = ['WHAT ARE YOU LOOKING FOR?'];
 // const texts = ['WHAT ARE YOU LOOKING FOR?', 'Search for something…','Search for other…','One more search'];
const input = document.querySelector('.predictive-search__input');
const animationWorker = function (input, texts) {
  this.input = input;
  this.defaultPlaceholder = this.input.getAttribute('placeholder');
  this.texts = texts;
  this.curTextNum = 0;
  this.curPlaceholder = '';
  this.blinkCounter = 0;
  this.animationFrameId = 0;
  this.animationActive = false;
  this.input.setAttribute('placeholder',this.curPlaceholder);

  this.switch = (timeout) => {
    this.input.classList.add('imitatefocus');
    setTimeout(
      () => {
        this.input.classList.remove('imitatefocus');
        if (this.curTextNum == 0)
          this.input.setAttribute('placeholder',this.defaultPlaceholder);
        else
          this.input.setAttribute('placeholder',this.curPlaceholder);

        setTimeout(
          () => {
            this.input.setAttribute('placeholder',this.curPlaceholder);
            if(this.animationActive)
              this.animationFrameId = window.requestAnimationFrame(this.animate)},
          timeout);
      },
      timeout);
  }

  this.animate = () => {
    if(!this.animationActive) return;
    let curPlaceholderFullText = this.texts[this.curTextNum];
    let timeout = 600;
    if (this.curPlaceholder == curPlaceholderFullText+'|' && this.blinkCounter==3) {
      this.blinkCounter = 0;
      this.curTextNum = (this.curTextNum >= this.texts.length-1)? 0 : this.curTextNum+1;
      this.curPlaceholder = '|';
      this.switch(000);
      return;
    }
    else if (this.curPlaceholder == curPlaceholderFullText+'|' && this.blinkCounter<3) {
      this.curPlaceholder = curPlaceholderFullText;
      this.blinkCounter++;
    }
    else if (this.curPlaceholder == curPlaceholderFullText && this.blinkCounter<3) {
      this.curPlaceholder = this.curPlaceholder+'|';
    }
    else {
      this.curPlaceholder = curPlaceholderFullText
        .split('')
        .slice(0,this.curPlaceholder.length+1)
        .join('') + '|';
      timeout = 140;
    }
    this.input.setAttribute('placeholder',this.curPlaceholder);
    setTimeout(
      () => { if(this.animationActive) this.animationFrameId = window.requestAnimationFrame(this.animate)},
      timeout);
  }

  this.stop = () => {
    this.animationActive = false;
    window.cancelAnimationFrame(this.animationFrameId);
  }

  this.start = () => {
    this.animationActive = true;
    this.animationFrameId = window.requestAnimationFrame(this.animate);
    return this;
  }
}
document.addEventListener("DOMContentLoaded", () => {
  let aw = new animationWorker(input, texts).start();
  input.addEventListener("focus", (e) => aw.stop());
  input.addEventListener("blur", (e) => {
    aw = new animationWorker(input, texts);
    if(e.target.value == '') setTimeout( aw.start, 1000);
  });
});


window.onload = () => {

  // hide app btns when drawer is open
  function listenDrawerAtrr() {
    const drawer_cart = document.querySelector('cart-drawer#mini-cart');
    const drawer_help = document.querySelector('#drawer_help');
    const drawers = drawer_cart || drawer_help;
    let observer = new MutationObserver(function(mutations) { // drawer observer
      mutations.forEach(function(mutation) {
        if (mutation.type === "attributes") {
          /* ✔ hide app btns when drawer open */
          if (drawers.hasAttribute('open')) {
            document.querySelector('#smile-ui-container') && (document.querySelector('#smile-ui-container').classList.add('widget-hidden'));  /* hide reward points app btn */
            document.querySelector('#dummy-chat-button-iframe') && (document.querySelector('#dummy-chat-button-iframe').classList.add('widget-hidden'));  /* hide chart app btn */
            document.querySelector('.kl-teaser-VV9SWy') && (document.querySelector('.kl-teaser-VV9SWy').classList.add('widget-hidden'));
            document.querySelector('#shopify-chat inbox-online-store-chat') && (document.querySelector('#shopify-chat inbox-online-store-chat').classList.add('widget-hidden'));
            document.querySelector('#giftbox-root iframe') && (document.querySelector('#giftbox-root iframe').classList.add('widget-hidden'));
            if (matchMedia('(max-width: 700px)').matches) { document.querySelector('.bacurr-choiceDesign') && (document.querySelector('.bacurr-choiceDesign').classList.add('widget-hidden')); }
          } else {
            document.querySelector('#smile-ui-container') && (document.querySelector('#smile-ui-container').classList.remove('widget-hidden')); /* show reward points app btn */
            document.querySelector('#dummy-chat-button-iframe') && (document.querySelector('#dummy-chat-button-iframe').classList.remove('widget-hidden'));  /* hide chart app btn */
            document.querySelector('.kl-teaser-VV9SWy') && (document.querySelector('.kl-teaser-VV9SWy').classList.remove('widget-hidden'));
            document.querySelector('#shopify-chat inbox-online-store-chat') && (document.querySelector('#shopify-chat inbox-online-store-chat').classList.remove('widget-hidden'));
            document.querySelector('#giftbox-root iframe') && (document.querySelector('#giftbox-root iframe').classList.remove('widget-hidden'));
            if (matchMedia('(max-width: 700px)').matches) { document.querySelector('.bacurr-choiceDesign') && (document.querySelector('.bacurr-choiceDesign').classList.remove('widget-hidden')); }
          }
        }
      });
    });
    observer.observe(drawers, {
      attributes: true //configure it to listen to attribute changes
    });
  } listenDrawerAtrr()
}


// max quantity value in product-form
// show tooltip for product with wariants
function maxItemVariant () {
  const qty_input = document.querySelector('quantity-selector input');
  const qty_incrs = qty_input.nextElementSibling || null;
  const variants = document.querySelectorAll('.block-swatch').length > 0 ? document.querySelectorAll('.block-swatch') : document.querySelectorAll('.color-swatch');

  variants.forEach(item => {
    item.addEventListener('click', () => {
      qty_incrs.removeAttribute('data-tooltip');
      setTimeout(() => {
        if (item.classList.contains('is-disabled')) {
          qty_input.setAttribute('max', 0);
          qty_input.value = 0;
          qty_incrs.removeAttribute('data-tooltip');
          qty_incrs.setAttribute('data-tooltip', `Out of stock`);
          return false;
        } else {
          qty_input.value = 1;
          qty_incrs.removeAttribute('data-tooltip');
        }
      }, 100);
    });
  });
}

maxItemVariant();

const qty_input = document.querySelector('quantity-selector input');
const qty_incrs = qty_input.nextElementSibling || null;
let observer = new MutationObserver(function(mutations) {
mutations.forEach(function(){
  const max_val = parseInt(qty_input.max);
  const inp_val = Number(qty_input.value);
    if (inp_val >= max_val) {
      qty_incrs.setAttribute('data-tooltip', `We only have ${max_val} in stock`);
      qty_incrs.classList.add('tooltip_prod_page');
      setTimeout(() => {
        qty_incrs.removeAttribute('data-tooltip');
        qty_incrs.classList.remove('tooltip_prod_page');
      }, 3000);
      if (max_val == 0) {
        qty_incrs.removeAttribute('data-tooltip');
        qty_incrs.classList.remove('tooltip_prod_page');
      }
    }
    else {
      qty_incrs.classList.remove('tooltip_prod_page');
      qty_incrs.removeAttribute('data-tooltip');
    };
  });
});
observer.observe(qty_input, {
  attributes: true,
  childList: true
});

// max quantity tooltip in cart drawer
function showTooltip(event) {
  let target = event.target; // get item with event
  let inputVal = parseInt(target.value); // get input string us num
  let max_qty = Number(target.getAttribute('max')); // max num value
  let incrBtn = target.nextElementSibling; // incrr btn
  if (inputVal >= max_qty) {
    setTimeout(() => {
      incrBtn.setAttribute('data-tooltip', `We only have ${max_qty} in stock`);
      incrBtn.classList.add('show_tooltip');
    }, 100)
    if (incrBtn.hasAttribute('data-tooltip')) {
      setTimeout(() => {
        incrBtn.classList.remove('show_tooltip');
      }, 3000)
    } else {
      setTimeout(() => {
        incrBtn.classList.remove('show_tooltip');
        incrBtn.removeAttribute('data-tooltip', `We only have ${max_qty} in stock`);
      }, 3000)
    }
  } return false;
}

let carouselInitialized = false;
let carouselWrapper = false;

window.addEventListener('jdgm.doneSetup', (e) => {
  let target = e.target;

  if(carouselInitialized) return;
  
  if(target && target.querySelector('.jdgm-carousel-wrapper') && !carouselInitialized) {
    carouselWrapper = target.querySelector('.jdgm-carousel-wrapper');
    carouselInitialized = true;
  };

  if(!carouselWrapper) return;

  let customersName = carouselWrapper.querySelectorAll('.jdgm-carousel-item__reviewer-name');
  let reviewsRating = carouselWrapper.querySelector('.jdgm-all-reviews-rating');

  const badgeHtml = new DOMParser().parseFromString('<span class="jdgm-badge"> Judge.me</span>', 'text/html');
  const reviewsRatingText = new DOMParser().parseFromString('<span class="jdgm-rating-text"> Judge.me</span>', 'text/html');

  reviewsRating.insertAdjacentHTML('afterend', reviewsRatingText.querySelector('.jdgm-rating-text').outerHTML);

  if(customersName.length > 0) {
    customersName.forEach(customerName => {
      customerName.innerText += ',';
      customerName.insertAdjacentHTML('beforeend', badgeHtml.querySelector('.jdgm-badge').outerHTML);
    })
  }
});
